export default "__VITE_ASSET__BD3X6BMb__"